import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { Check } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 px-4 bg-forest relative overflow-hidden" data-id="element-91">
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-forest-light/20 via-forest to-forest pointer-events-none" data-id="element-92"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-93">
        <div className="text-center mb-16" data-id="element-94">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8 leading-tight text-cream" data-id="element-95">
            El próximo lunes podés seguir improvisando...
            <br data-id="element-96" />
            <span className="text-gold-gradient" data-id="element-97">
              O podés entrar al aula con todo listo desde hoy.
            </span>
          </h2>

          <div className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-forest-dark p-8 rounded-2xl border border-forest-light" data-id="element-98">
            {['Sin más noches buscando cómo explicar el ciclo del cultivo o la diferencia entre sistemas de riego', 'Sin más clases armadas de apuro con material que no funciona ni se adapta a tu contexto', 'Sin más alumnos desconectados que no entienden para qué sirve aprender producción agropecuaria', 'Sin más fines de semana perdidos construyendo material desde cero', 'Sin más silencios incómodos frente a preguntas técnicas que te ponen en aprietos'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-99">
                <span className="text-gold mt-1" data-id="element-100">▸</span>
                <span className="text-cream-dark" data-id="element-101">{item}</span>
              </div>)}
          </div>

          <p className="text-xl text-cream mb-2" data-id="element-102">
            El Mega Pack Producción Agropecuaria 360° no te convierte en mejor
            docente.
          </p>
          <p className="text-2xl font-bold text-gold mb-6" data-id="element-103">
            Vos ya sos un buen docente.
          </p>
          <p className="text-xl text-cream-dark mb-16" data-id="element-104">
            Lo que hace el Mega Pack es darte el tiempo y las herramientas para
            que eso se note en cada clase, en cada práctica, en cada proyecto
            que tus alumnos llevan al campo.
          </p>
        </div>

        <div className="bg-white border-2 border-gold/50 rounded-3xl p-8 md:p-12 shadow-[0_0_40px_rgba(212,175,55,0.2)]" data-id="element-105">
          <h3 className="text-2xl font-bold text-slate-900 mb-6 text-center border-b border-earth/20 pb-6" data-id="element-106">
            Todo lo que incluye:
          </h3>

          <div className="grid md:grid-cols-2 gap-x-8 gap-y-4 mb-10" data-id="element-107">
            {['Tomo 1 — Fundamentos de la Producción Agropecuaria', 'Tomo 2 — Producción Vegetal y Ganadería Bovina', 'Tomo 3 — Riego, Maquinaria y Seguridad Rural', 'Tomo 4 — Sustentabilidad y Producción Animal', 'Tomo 5 — Del Campo al Mercado', 'Bono 1 — Clases organizadas y listas para usar', 'Bono 2 — Actividades prácticas para el aula y el taller', 'Bono 3 — Evaluaciones y criterios de corrección', 'Bono 4 — Proyectos Finales Productivos', 'Garantía de 7 días sin preguntas', 'Pago en tu moneda local', 'Acceso inmediato', 'Formato PDF listo para usar'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-108">
                <Check size={18} className="text-forest shrink-0" data-id="element-109" />
                <span className="text-sm text-slate-700" data-id="element-110">{item}</span>
              </div>)}
          </div>

          <div className="text-center" data-id="element-111">
            <div className="mb-8 p-6 bg-cream rounded-xl border border-earth/20 italic text-slate-700 text-lg shadow-sm" data-id="element-112">
              "El mejor momento para tener este material era al inicio del año.
              <br data-id="element-113" />
              <span className="text-forest font-bold not-italic" data-id="element-114">
                El segundo mejor momento es hoy.
              </span>
              "
            </div>

            <p className="text-xl font-serif font-bold text-slate-900 mb-2" data-id="element-115">
              📚 Mega Pack Producción Agropecuaria 360°
            </p>
            <p className="text-sm text-slate-500 mb-8" data-id="element-116">
              Hecho por especialistas, para docentes técnicos y rurales de todo
              el mundo hispanohablante.
            </p>

            <Button href="#pricing" className="w-full md:w-auto text-xl py-6 px-12 mb-6" data-id="element-117">
              🟡 QUIERO MI MEGA PACK AHORA
            </Button>

            <div className="flex flex-wrap justify-center gap-4 text-xs text-slate-500 font-medium" data-id="element-118">
              <span data-id="element-119">✅ Garantía de 7 días</span>
              <span data-id="element-120">✅ Pago seguro</span>
              <span data-id="element-121">✅ Acceso inmediato</span>
              <span data-id="element-122">✅ Pagás en tu moneda local</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}